import { render, staticRenderFns } from "./itemsList.vue?vue&type=template&id=fc554fae&scoped=true&"
import script from "./itemsList.vue?vue&type=script&lang=js&"
export * from "./itemsList.vue?vue&type=script&lang=js&"
import style0 from "./itemsList.vue?vue&type=style&index=0&id=fc554fae&prod&scoped=true&lang=scss&"
import style1 from "./itemsList.vue?vue&type=style&index=1&id=fc554fae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc554fae",
  null
  
)

export default component.exports